import sessionStorage from '@/utils/storage/sessionStorage';

const state = {
  fee: sessionStorage.get('fee'),
  providerId: sessionStorage.get('providerId'),
  goodsIds: sessionStorage.get('goodsIds')
};

const getters = {};

const mutations = {
  setFee(state, fee) {
    state.fee = fee.params;
    // 同时本地存储
    sessionStorage.set('fee', fee.params);
  },
  setProviderId(state, pro) {
    state.providerId = pro.params;
    sessionStorage.set('providerId', pro.params);
  },
  setGoodsIds(state, pro) {
    state.goodsIds = pro.params;
    sessionStorage.set('goodsIds', pro.params);
  }
};

const actions = {};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
